import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
  LocalStorageEnum,
  SessionStorageEnum,
  StorageService,
} from 'src/app/shared/storage.service';
import { environment } from 'src/environments/environment';
import { DialogService } from '../../dialog.service';

const upgradeLabel = `Your 14-day trial has expired and your account now has limited functionality. To regain access to the full power of the BioDigital Human platform, choose the plan that’s perfect for you and:`;

@Component({
  selector: 'app-trial-expired-dialog',
  templateUrl: './trial-expired-dialog.component.html',
  styleUrls: ['./trial-expired-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialExpiredDialogComponent implements OnInit {
  supportEmail = environment.supportEmail;
  upgradeLabel = upgradeLabel;

  constructor(
    private dialogService: DialogService,
    private storageService: StorageService,
    private dialogRef: MatDialogRef<any>,
  ) {}

  ngOnInit(): void {}

  handleCancelClick() {
    this.storageService.setLocalItem(LocalStorageEnum.TeamTrialExpirationSeen, true);
    this.dialogRef.close();
  }

  handleChooseClick() {
    this.storageService.setLocalItem(LocalStorageEnum.TeamTrialExpirationSeen, true);
    this.dialogService.openUpgradeDialog();
  }
}
